import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shorten'
})
export class ShortenPipe implements PipeTransform {

  transform(value: string): string {
    let lineBreaks = value.split("\n");

    if(lineBreaks.length > 3) {
      return lineBreaks.slice(0, 3).join("\n");
    } else {
      return value;
    }
  }

}
